import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import EnvironmentManager from 'Utils/environmentManager';

const NotFound = loadable(() => pMinDelay(import('./NotFound'), 300), {
  fallback: <Loading />
});

const TjkNotFound = loadable(() => pMinDelay(import('./TjkNotFound'), 300), {
  fallback: <Loading />
});

const AsyncNotFound = props => {
  const pageConfig = {
    headerType: 'simple',
    footerType: 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  const isTjkFetched = EnvironmentManager.isTjkMessagesReady();
  const hasTjkMessages = EnvironmentManager.tjkMessages && EnvironmentManager.tjkMessages.length > 0;
  
  const showTjkError = isTjkFetched && !hasTjkMessages;
  
  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      { showTjkError ? <TjkNotFound { ...props }/> : <NotFound { ...props }/> }
    </ApplicationLayout>
  );
};

AsyncNotFound.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncNotFound;
